import { styled } from '../muiReexports';
export const InnerContainer = styled('div')({
    // Necessary to fit child.
    // If parent bigger than child then tooltip can be shown, but copy to clipboard event (link click) will not have worked.
    display: 'inline',
});
